export enum HttpsCallableName {
  searchItem = 'searchItem',
}
